import { render, staticRenderFns } from "./PageTabnav.vue?vue&type=template&id=412aaa86&"
import script from "./PageTabnav.vue?vue&type=script&lang=js&"
export * from "./PageTabnav.vue?vue&type=script&lang=js&"
import style0 from "./PageTabnav.vue?vue&type=style&index=0&id=412aaa86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports